import { IObjectTranslatable } from ".";
import { IMovableImageItemBean, ITypeDefinable, BeanTypes } from "../beans/items";
import { IItem, MovableImageItem } from "../../../../domain/document/items";
import { ImageSource } from "..";

import {
  Point,
  Rectangle,
  Size,
} from "../../../../domain/drawing";

export class MovableImageItemTranslator implements IObjectTranslatable {
  constructor(private _getToken: () => string) {
  }

  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as IMovableImageItemBean;
    const result = new MovableImageItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.imageSource = new ImageSource(this._getToken, formatId, documentId, bean.imageStoragePlace, bean.imageGuid);
    result.originalImageSource = new ImageSource(this._getToken, formatId, documentId, bean.originalImageStoragePlace, bean.originalImageGuid);
    result.drawLayerImageSource = new ImageSource(this._getToken, formatId, documentId, bean.drawLayerImageStoragePlace, bean.drawLayerImageGuid);
    result.drawObjectData = (bean.drawObjectData != null) ? bean.drawObjectData : null;
    result.imageKind = bean.imageType;
    result.claioImageId = (bean.claioImageKey != null) ? bean.claioImageKey.toString() : null;
    result.shouldQuote = !!bean.isQuotable;
    result.supportedQuotable = !!bean.supportedQuotable;
    result.isResizeRequired = false;
    result.rotationAngle = bean.rotationAngle;
    result.imageDepartmentId = bean.imageDepartmentCode;
    result.isFreeDrawn = !!bean.isFreeDrawn;
    result.externalImageId = bean.externalImageKey;
    return result;
  }

  toBean(item: IItem): IMovableImageItemBean {
    const target = item as MovableImageItem;
    return {
      type: BeanTypes.MovableImage,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: Math.floor(target.geometry.rectangle.x),
      y: Math.floor(target.geometry.rectangle.y),
      width: Math.floor(target.geometry.rectangle.width),
      height: Math.floor(target.geometry.rectangle.height),
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      imageStoragePlace: target.imageSource.imageSourceKind,
      imageGuid: target.imageSource.imageGuid,
      imageQuotedformatId: target.imageSource.quotedFormatId,
      imageType: target.imageKind,
      claioImageKey: target.claioImageId ? parseInt(target.claioImageId, 10) : null,
      isQuotable: target.shouldQuote,
      supportedQuotable: target.supportedQuotable,
      rotationAngle: target.rotationAngle ? target.rotationAngle : 0,
      imageDepartmentCode: target.imageDepartmentId,
      isFreeDrawn: target.isFreeDrawn,
      externalImageKey: target.externalImageId,
      originalImageStoragePlace: target.originalImageSource.imageSourceKind,
      originalImageGuid: target.originalImageSource.imageGuid,
      drawLayerImageStoragePlace: target.drawLayerImageSource.imageSourceKind,
      drawLayerImageGuid: target.drawLayerImageSource.imageGuid,
      drawObjectData: target.drawObjectData,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
    };
  }
}
